import { createReducer } from './../../utilities/miscellaneous'

export const INITIAL_STATE = {
  scriptImported: false,
  displayInterstitialAd: false,
}

export const SCRIPT_IMPORTED = 'adnimation/SCRIPT_IMPORTED'
export const TOGGLE_INTERSTITIAL_AD = 'adnimation/TOGGLE_INTERSTITIAL_AD'

export const scriptImported = () => ({ type: SCRIPT_IMPORTED })
export const toggleInterstitialAd = () => ({ type: TOGGLE_INTERSTITIAL_AD })

export default createReducer(INITIAL_STATE, {
  [SCRIPT_IMPORTED]: state => ({
    ...state,
    scriptImported: true,
  }),
  [TOGGLE_INTERSTITIAL_AD]: state => ({
    ...state,
    displayInterstitialAd: !state.displayInterstitialAd,
  }),
})
